import React from 'react'
import { Navigate } from 'react-router-dom';
import { useSessionStore } from '../hooks/useSessionStore'

/**
 * If the user is an admin, show the children, otherwise redirect to the login page
 */
export const PrivateAdmin = ({ children }) => {

    /* Using the useSessionStore hook to get the user from the local storage. */
    const [Usuario, setUsuario] = useSessionStore({});

    return (Usuario.tipo === "usuarioAdmin")
        ? children
        : (Usuario.tipo === undefined)
            ? <Navigate to="/" />
            : (Usuario.tipo === "usuarioNormal")
                ? <Navigate to="/" />
                : (Usuario.tipo === "usuarioEmpresa")
                    && <Navigate to="/miEmpresa" />
}